/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */
class FilterComponent extends HTMLElement {
  constructor() {
    super();
    this.toggleButton = null;
    this.verticalFilter = null;
    this.buttonList = null;
    this.buttonGrid = null;
    this.grid = null;
    this.list = null;
    this.drawerFilterButton = null;
    this.drawerFilter = null;
    this.buttonCloseDrawerFilter = null;
    this.overlay = null;
    this.selectedSort = "";
  }

  connectedCallback() {
    this.filters = this.querySelectorAll("filter-dropdown-item");
    this.selectedFilters = [];
    this.currentFilterToUpdate = null;

    this.sectionId = this.getAttribute("section-id");

    this.inputPriceRange = this.querySelector("filter-price");

    // price filters
    this.getGlobalMinMax();

    this.removeAllFilter();
    this.handleVerticalFilter();
    this.handleViewToggle();
    this.handleDrawerFilter();

    // Attach listener for active filter removal
    this.addEventListener("click", (event) => {
      const target = event.target.closest(".active-filter");
      if (target) {
        this.removeActiveFilter(target);
      }
    });

    this.sortDropwdown = this.querySelector(".js-sorting-selector");

    this.selectedSort = this.sortDropwdown.querySelector(".sorting-selector__value").getAttribute("data-sort-option");

    this.sortDropwdown.querySelectorAll(".sorting-selector__option").forEach((sort) => {
      sort.addEventListener("click", () => {
        this.selectedSort = sort.getAttribute("data-sort-option");
        this.updateCollection();
      });
    });

    this.addEventListener("filterUpdate", (event) => {
      this.collectFilters(event);
    });

    if (window.location.href.includes("filter.") || localStorage.getItem("filterOpen") === "open") {
      const toggle = this.querySelector(".js-filter-header__filter toggle-component input");
      if (toggle && !toggle.checked) {
        toggle.click();
      }
    }

    /* sticky vertical filter */
    this.stickyVerticalFilter = this.querySelector(".products__vertical-filter");
    this.currentTop = Number.parseInt(
      document.documentElement.scrollTop +
        this.stickyVerticalFilter.parentElement.getBoundingClientRect().top -
        this.parentElement.offsetTop,
      10,
    );
    this.defaultTop = 0;
    this.scrollY = window.scrollY;
    window.addEventListener("scroll", this.handleScroll.bind(this));
  }

  handleScroll() {
    const maxTop =
      this.stickyVerticalFilter.getBoundingClientRect().top +
      window.scrollY -
      this.stickyVerticalFilter.offsetTop +
      this.defaultTop;
    const minTop = this.stickyVerticalFilter.clientHeight - window.innerHeight;
    window.scrollY < this.scrollY
      ? (this.currentTop -= window.scrollY - this.scrollY)
      : (this.currentTop += this.scrollY - window.scrollY);
    this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.defaultTop);
    this.scrollY = window.scrollY;
    this.stickyVerticalFilter.style.top = `${this.currentTop}px`;
  }

  getGlobalMinMax() {
    const urlParams = new URLSearchParams(window.location.search);
    let toFetch = "";
    if (urlParams.has("q")) {
      toFetch = `&q=${urlParams.get("q")}`;
    }

    fetch(`${window.location.pathname}?section_id=${this.sectionId}${toFetch}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        const maxInputEl = html.querySelector(".filter-price-inputs__max input");
        const minInputEl = html.querySelector(".filter-price-inputs__min input");

        const inputMax = maxInputEl ? parseFloat(maxInputEl.value) : 0;
        const inputMin = minInputEl ? parseFloat(minInputEl.value) : 0;

        this.globalMinMax = {
          min: inputMin,
          max: inputMax,
        };
        this.initPriceFilters();
      })
      .catch((error) => {
        console.error("Failed to update collection:", error);
        this.loading(false);
      });
  }

  initPriceFilters() {
    const priceFilters = Array.from(this.querySelectorAll(".filter-price-inputs__max"))
      .map((input) => input.closest(".filter-price"))
      .filter((filter) => filter !== null);
    priceFilters.forEach((pf) => {
      pf.init(this.globalMinMax.min, this.globalMinMax.max);
    });
  }

  collectFilters(event) {
    if (event.detail.type !== "sort-input") {
      this.selectedFilters = [];
      this.currentFilterToUpdate = event.detail;
      this.filters.forEach((filter) => {
        if (filter.parentElement.parentElement === event.detail.element.parentElement.parentElement) {
          this.selectedFilters = this.selectedFilters.concat(filter.getFilterURLs());
        }
      });
      // New filters logic
      // Log the newly selected filters, filter kind, and current selected filters
      const newFilters = event.detail.element.selectedFiltersValues;
      const filterKind = event.detail.element.targetAttribute
        ? event.detail.element.targetAttribute.split("=")[0]
        : null;

      // Check for express_tag
      const hasExpressTag = newFilters.some((filter) => filter.includes("filter.p.m.custom.express_tag=Ja"));
      if (filterKind === "filter.p.m.custom.express_tag" && hasExpressTag) {
        if (this.selectedFilters.includes("filter.v.availability=0")) {
          this.selectedFilters = this.selectedFilters.filter((f) => f !== "filter.v.availability=0");
          this.filters.forEach((filter) => {
            const selectedInput = filter.querySelector('input[data-filter-to-add="filter.v.availability=0"]');
            if (selectedInput) {
              filter.selectedFiltersValues = ["filter.v.availability=1"];
              selectedInput.checked = false;
            }
          });
        }
        if (!this.selectedFilters.includes("filter.v.availability=1")) {
          this.selectedFilters.push("filter.v.availability=1");
          this.filters.forEach((filter) => {
            const selectedInput = filter.querySelector('input[data-filter-to-add="filter.v.availability=1"]');
            if (selectedInput) {
              selectedInput.checked = true;
            }
          });
        }
      }
      this.updateCollection();
    } else if (event.detail.sortValue) {
      // eslint-disable-next-line prefer-destructuring
      this.sortDropwdown.querySelectorAll(".sorting-selector__option").forEach((sort) => {
        if (sort.getAttribute("data-sort-option") === event.detail.sortValue) {
          sort.click();
        }
      });
    } else {
      // eslint-disable-next-line prefer-destructuring
      this.sortDropwdown.querySelectorAll(".sorting-selector__option").forEach((sort) => {
        if (sort.getAttribute("data-sort-option") === event.detail.element.getFilterURLs()[0].split("=")[1]) {
          sort.click();
        }
      });
    }
  }

  removeActiveFilter(button) {
    const filter = button.getAttribute("data-filter");
    const value = button.getAttribute("value");

    // Find the specific input associated with the clicked filter
    const input = this.querySelector(`input[data-filter-to-add='${filter}']`);

    if (input) {
      if (!value) {
        // If no value is specified, uncheck and reset only this specific filter input
        input.checked = false;
      } else {
        // Handle resetting specific filter types, e.g., price ranges
        const min = this.inputPriceRange.getAttribute("min");
        const max = this.inputPriceRange.getAttribute("max");
        if (input.getAttribute("data-filter-to-add") === "filter.v.price.gte=") {
          input.value = min;
        } else {
          input.value = max;
        }
      }

      // Trigger a "change" event only for this specific input
      const changeEvent = new Event("change", {
        bubbles: true, // Allows the event to bubble up the DOM
        cancelable: true, // Makes the event cancelable
      });
      input.dispatchEvent(changeEvent); // Dispatch the event for the specific input
    }

    // Update the collection without affecting other filters
    this.updateCollection();
  }

  disconnectedCallback() {
    // Cleanup event listeners
    if (this.toggleButton) {
      this.toggleButton.removeEventListener("change", this.toggleVerticalFilter);
    }
    if (this.buttonGrid) {
      this.buttonGrid.removeEventListener("click", this.toggleGridView);
    }
    if (this.buttonList) {
      this.buttonList.removeEventListener("click", this.toggleListView);
    }
    if (this.drawerFilterButton) {
      this.drawerFilterButton.removeEventListener("click", this.openDrawer);
    }
    if (this.buttonCloseDrawerFilter) {
      this.querySelector(".filter-drawer__footer-btn").removeEventListener("click", this.closeDrawer);
      this.buttonCloseDrawerFilter.removeEventListener("click", this.closeDrawer);
    }
  }

  handleDrawerFilter() {
    this.drawerFilter = this.querySelector(".collection-products-section__filter-drawer-container");
    this.drawerFilterButton = this.querySelector(".filter-header__filter .filter-sorting-btn");
    this.buttonCloseDrawerFilter = this.drawerFilter.querySelector(".filter-drawer-header__close");
    this.overlay = this.drawerFilter.querySelector(".collection-products-section__filter-drawer-overlay");
    this.drawerFooterBtn = this.querySelector(".filter-drawer__footer-btn");

    if (this.drawerFilterButton) {
      this.drawerFilterButton.addEventListener("click", this.openDrawer.bind(this));
    }

    if (this.buttonCloseDrawerFilter) {
      this.buttonCloseDrawerFilter.addEventListener("click", this.closeDrawer.bind(this));
    }

    if (this.overlay) {
      this.overlay.addEventListener("click", this.closeDrawer.bind(this));
    }

    if (this.drawerFooterBtn) {
      this.querySelector(".filter-drawer__footer-btn").addEventListener("click", this.closeDrawer.bind(this));
    }
  }

  openDrawer() {
    if (this.drawerFilter) {
      this.drawerFilter.classList.add("collection-products-section__filter-drawer-container--open");
    }
  }

  closeDrawer() {
    if (this.drawerFilter) {
      this.drawerFilter.classList.remove("collection-products-section__filter-drawer-container--open");
    }
  }

  handleVerticalFilter() {
    this.toggleButton = this.querySelector(".filter-header__filter input");
    this.verticalFilter = this.querySelector(".products__vertical-filter");
    if (!localStorage.getItem("filterOpen")) {
      localStorage.setItem("filterOpen", "open");
    }

    if (this.toggleButton) {
      this.toggleButton.addEventListener("change", this.toggleVerticalFilter.bind(this));
    }
  }

  toggleVerticalFilter(e) {
    if (e.target.checked) {
      this.verticalFilter.classList.remove("products__vertical-filter--hidden");
      localStorage.setItem("filterOpen", "open");
    } else {
      this.verticalFilter.classList.add("products__vertical-filter--hidden");
      localStorage.setItem("filterOpen", "close");
    }
  }

  handleViewToggle() {
    this.buttonList = this.querySelector(".view-as__list-button");
    this.buttonGrid = this.querySelector(".view-as__grid-button");

    this.grid = this.querySelector(".products-grid");
    this.list = this.querySelector(".products-list");

    if (this.buttonGrid) {
      this.buttonGrid.addEventListener("click", this.toggleGridView.bind(this));
    }

    if (this.buttonList) {
      this.buttonList.addEventListener("click", this.toggleListView.bind(this));
    }

    // if (!localStorage.getItem("listViewOpen")) {
    //   localStorage.setItem("listViewOpen", "close");
    // } else if (localStorage.getItem("listViewOpen") === "open") {
    //   this.buttonList.click();
    // }
  }

  toggleGridView() {
    this.grid.classList.remove("products__view--hide");
    this.list.classList.add("products__view--hide");
    localStorage.setItem("listViewOpen", "close");
  }

  toggleListView() {
    this.grid.classList.add("products__view--hide");
    this.list.classList.remove("products__view--hide");
    localStorage.setItem("listViewOpen", "open");
  }

  updateURL() {
    const baseURL = window.location.href.split("?")[0]; // Get the base URL without the query string

    // Start building the query string manually
    let queryString = "";

    // Get the current URL's query parameters
    const currentParams = new URLSearchParams(window.location.search);

    // Preserve the search query if it exists
    const searchQ = currentParams.get("q");
    if (searchQ) {
      queryString += `q=${searchQ}&`;
    }

    // Deduplicate and group filters by key (e.g., filter.p.vendor)
    const filterMap = new Map();
    this.selectedFilters.forEach((filter) => {
      const [key, value] = filter.split("=");

      if (filterMap.has(key)) {
        filterMap.get(key).add(value); // Add to set to deduplicate values for the same key
      } else {
        filterMap.set(key, new Set([value])); // Initialize a set for new filter key
      }
    });

    // Add unique filters to query string
    filterMap.forEach((values, key) => {
      values.forEach((value) => {
        queryString += `${key}=${encodeURIComponent(value)}&`;
      });
    });

    // Ensure only one sort_by parameter
    queryString = queryString.replace(/sort_by=[^&]*&?/g, ""); // Remove existing sort_by
    if (this.selectedSort) {
      queryString += `sort_by=${this.selectedSort}&`;
    }

    // Extract the current page number from the URL, if available
    const page = currentParams.get("page");
    if (page) {
      queryString += `page=1&`;
    }

    // Remove trailing '&' if it exists
    queryString = queryString.replace(/&$/, "");

    // Construct the final URL
    const newUrl = `${baseURL}?${queryString}`;

    // Update the browser's URL without reloading the page
    window.history.replaceState({ path: newUrl }, "", newUrl);

    return `&${queryString}`; // Return the query string if needed elsewhere
  }

  updateCollection() {
    this.loading(true);
    const toFetch = this.updateURL();
    fetch(`${window.location.pathname}?section_id=${this.sectionId}${toFetch}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const selectors = [
          ".search-header",
          ".collection-products__wrapper",
          ".filter-drawer__footer button span",
          ".js-filter-drawer__body .js-used-filters-mobile",
          ".js-filter-drawer__body .js-filter-drawer-sort-header",
        ];
        selectors.forEach((selector) => {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        });

        if (this.currentFilterToUpdate && this.currentFilterToUpdate.type !== "sort-input") {
          const filtersToUpdate = this.querySelectorAll(`#${this.currentFilterToUpdate.element.id}`);
          filtersToUpdate.forEach((f) => {
            // eslint-disable-next-line no-param-reassign
            f.innerHTML = html.querySelector(`#${this.currentFilterToUpdate.element.id}`).innerHTML;
            if (this.currentFilterToUpdate.type === "checkbox") {
              f.init();
            } else if (this.currentFilterToUpdate.type === "price") {
              f.init();
              if (f.querySelector("filter-price")) {
                f.querySelector("filter-price").init(this.globalMinMax.min, this.globalMinMax.max);
              }
            }
          });
          this.currentFilterToUpdate = undefined;
        } else if (this.currentFilterToUpdate && this.currentFilterToUpdate.type === "sort-input") {
          const filterToUpdate = this.querySelector(`#${this.currentFilterToUpdate.element.id}`);
          filterToUpdate.innerHTML = html.querySelector(`#${this.currentFilterToUpdate.element.id}`).innerHTML;
          this.currentFilterToUpdate = undefined;
        }

        if (this.updateAll) {
          const lists = document.querySelectorAll("filter-dropdown-list");
          lists.forEach((list) => {
            list.innerHTML = html.querySelector("filter-dropdown-list").innerHTML;
            const filters = list.querySelectorAll("filter-dropdown-item");
            filters.forEach((f) => {
              f.init();
              if (f.querySelector("filter-price")) {
                f.querySelector("filter-price").init(this.globalMinMax.min, this.globalMinMax.max);
              }
            });
          });
          this.filters = this.querySelectorAll("filter-dropdown-item");
          this.updateAll = false;
        }

        // Scroll to top of filter-component
        const filterComponent = this.closest("filter-component");
        if (filterComponent) {
          filterComponent.scrollIntoView({ behavior: "smooth" });
        }

        this.loading(false);
        this.attachListeners();
        // Dynamically update filter counts (new addition)
        this.updateFilterCounts(html);

        if (localStorage.getItem("listViewOpen") === "open") {
          this.buttonList.click();
        }
      })
      .catch((error) => {
        console.error("Failed to update collection:", error);
        this.loading(false);
      });
  }

  updateFilterCounts(html) {
    // Select all filter checkboxes from the current component
    const allFilterCheckboxes = this.querySelectorAll(".filter-checkboxes__input");

    // Loop through each checkbox and update its count and disabled state dynamically
    allFilterCheckboxes.forEach((checkbox) => {
      const inputElement = checkbox.querySelector("input");
      const filterParam = inputElement.getAttribute("data-filter-to-add");
      const sourceCheckbox = html.querySelector(`.filter-checkboxes__input input[data-filter-to-add='${filterParam}']`);

      if (sourceCheckbox) {
        const sourceCount = sourceCheckbox
          .closest(".filter-checkboxes__input")
          .querySelector(".filter-checkboxes__count-option");
        const targetCount = checkbox.querySelector(".filter-checkboxes__count-option");

        if (sourceCount && targetCount) {
          // Update the count dynamically
          targetCount.textContent = sourceCount.textContent;

          // Disable the input if count is 0
          if (parseInt(sourceCount.textContent, 10) === 0) {
            inputElement.disabled = true;
          } else {
            inputElement.disabled = false;
          }
        }
      }
    });
  }

  loading(isLoading = true) {
    const elements = [
      ...this.querySelectorAll("filter-dropdown-list"),
      this.querySelector(".active-filters"),
      this.querySelector("sorting-selector"),
    ];

    elements.forEach((element) => {
      if (element) {
        element.classList.toggle("filter--loading", isLoading);
      }
    });
  }

  attachListeners() {
    this.removeAllFilter();
    this.handleViewToggle();
  }

  removeAllFilter() {
    const removeAllButtons = this.querySelectorAll(".js-reset-filters");
    removeAllButtons.forEach((removeAllButton) => {
      removeAllButton.addEventListener("click", () => {
        this.selectedFilters = [];
        this.updateAll = true;
        this.updateCollection();
      });
    });
  }
}

// Register the custom element

if (!customElements.get("filter-component")) {
  customElements.define("filter-component", FilterComponent);
}
